import { useMutation } from "@tanstack/react-query";
import { http } from "../../shared/api/http.js";
import type { CreateQuoteRequestInput } from "@smartvow/shared";

export const useSubmitQuoteRequest = () =>
  useMutation({
    mutationFn: (data: CreateQuoteRequestInput) => http.post("/quote-requests", data),
  });
